import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BDropdown, BDropdownItem } from "bootstrap-vue";
import { computed } from "vue";
import { prependPath } from "@/utils/redirect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetDownload',
    props: {
        item: null
    },
    emits: ["on-download"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faSave);
        const metaFiles = computed(() => {
            return props.item.meta_files;
        });
        const hasMetaFiles = computed(() => {
            return metaFiles.value && metaFiles.value.length > 0;
        });
        const metaDownloadUrl = computed(() => {
            return prependPath(`api/datasets/${props.item.id}/metadata_file?metadata_file=`);
        });
        const downloadUrl = computed(() => {
            return prependPath(`api/datasets/${props.item.id}/display?to_ext=${props.item.extension}`);
        });
        function onDownload(resource, extension = "") {
            emit("on-download", `${resource}${extension}`);
        }
        return { __sfc: true, props, emit, metaFiles, hasMetaFiles, metaDownloadUrl, downloadUrl, onDownload, faSave, FontAwesomeIcon, BButton, BDropdown, BDropdownItem };
    }
});
